import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, logout, userInfo, hasSlackRole } = useAuth();

  const isSupportRoute = location.pathname.startsWith('/customer-requests');
  const isCoachingRoute = location.pathname.startsWith('/driver-coaching');
  const isConfigRoute = location.pathname.startsWith('/slack-channel-configurations');

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <nav style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '2rem',
      background: '#0740a3',
      borderBottom: '1px solid #eee',
      height: '75px',
      position: 'sticky',
      top: 0,
      zIndex: 1000,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => navigate('/')}>
        <img src={process.env.PUBLIC_URL + '/images/bt-logo.svg'} alt="Better Trucks" style={{ height: 40, marginRight: 16 }} />
      </div>
      <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
        {isAuthenticated && hasSlackRole && (
          <>
            <button
              onClick={() => navigate('/customer-requests')}
              style={{
                background: isSupportRoute ? 'rgba(255, 255, 255, 0.2)' : 'none',
                border: 'none',
                color: '#fff',
                fontWeight: 600,
                fontSize: 16,
                cursor: 'pointer',
                padding: '0.5rem 1rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                borderRadius: '4px',
                transition: 'background-color 0.2s',
              }}
              onMouseEnter={(e) => {
                if (!isSupportRoute) e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
              }}
              onMouseLeave={(e) => {
                if (!isSupportRoute) e.currentTarget.style.backgroundColor = 'transparent';
              }}
            >
              <i className="bi bi-headset"></i>
              Support Requests
            </button>
            <button
              onClick={() => navigate('/driver-coaching')}
              style={{
                background: isCoachingRoute ? 'rgba(255, 255, 255, 0.2)' : 'none',
                border: 'none',
                color: '#fff',
                fontWeight: 600,
                fontSize: 16,
                cursor: 'pointer',
                padding: '0.5rem 1rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                borderRadius: '4px',
                transition: 'background-color 0.2s',
              }}
              onMouseEnter={(e) => {
                if (!isCoachingRoute) e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
              }}
              onMouseLeave={(e) => {
                if (!isCoachingRoute) e.currentTarget.style.backgroundColor = 'transparent';
              }}
            >
              <i className="bi bi-person-video2"></i>
              Driver Coaching
            </button>
            <button
              onClick={() => navigate('/slack-channel-configurations')}
              style={{
                background: isConfigRoute ? 'rgba(255, 255, 255, 0.2)' : 'none',
                border: 'none',
                color: '#fff',
                fontWeight: 600,
                fontSize: 16,
                cursor: 'pointer',
                padding: '0.5rem 1rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                borderRadius: '4px',
                transition: 'background-color 0.2s',
              }}
              onMouseEnter={(e) => {
                if (!isConfigRoute) e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
              }}
              onMouseLeave={(e) => {
                if (!isConfigRoute) e.currentTarget.style.backgroundColor = 'transparent';
              }}
            >
              <i className="bi bi-gear"></i>
              Slack Channels
            </button>
          </>
        )}
        {isAuthenticated && (
          <>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: '1rem',
              padding: '0.25rem 0.75rem',
              background: 'rgba(255, 255, 255, 0.15)',
              borderRadius: '4px',
              color: '#fff'
            }}>
              <i className="bi bi-person-circle me-2" style={{ fontSize: '14px' }}></i>
              <span style={{ fontWeight: 500, fontSize: '14px' }}>
                {userInfo?.email || 'User'}
              </span>
            </div>
            <button
              onClick={handleLogout}
              className="btn btn-outline-light btn-sm"
              style={{ fontWeight: 600 }}
            >
              <i className="bi bi-box-arrow-right me-1"></i>
              Logout
            </button>
          </>
        )}
        {!isAuthenticated && (
          <button
            onClick={() => navigate('/login')}
            className="btn btn-outline-light btn-sm"
            style={{ fontWeight: 600 }}
          >
            <i className="bi bi-box-arrow-in-right me-1"></i>
            Login
          </button>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
